<template>
  <ChipGeneric
    :item="computed_item"
    :key="'item_'+item.value"
    @update="chip_clicked"
  />
</template>
  
  
<script>
  import { mapState } from 'vuex';
  import ChipGeneric from '@/components/explorer/chips/ChipGeneric';
  
  export default {
    name: 'UserChip',
  
    props: {
      item: {type: Object},
      disable: {
       type: Boolean,
       default: false,
     },
    },
  
    components: {
      ChipGeneric,
    },

    computed: {
      ...mapState(['users']),
      computed_item() {
        return  {
                  readable: this.text,
                  readableValue: this.user_name,
                }
      },
      text() {
        return this.item.readable || this.item.name ||  this.$vuetify.lang.translator('user');
      },
      current_user() {
        return this.users.find(usr => usr.id === this.item.value);
      },
      user_name() {
        return this.current_user ?
               this.current_user.first_name+' '+this.current_user.last_name :
               'user_' + this.item.value;
      }
    },
  
    methods: {
      chip_clicked(item){
        this.$emit('update',this.item);
      },
    },
  }
</script>